(() => {
  if (window.__cleoVariantCardSelector) return;
  window.__cleoVariantCardSelector = true;

  document.addEventListener(
    'click',
    (event) => {
      const selector = event.target.closest('[data-variant-card-selector]');
      if (!selector) return;

      const card = selector.closest('product-card');
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();

      const variantId = selector.dataset.variantId;
      const variantUrl = selector.dataset.variantUrl || selector.href;
      const variantImage = selector.dataset.variantImage;
      const variantImageAlt = selector.dataset.variantImageAlt;
      const variantPrice = selector.dataset.variantPrice;
      const comparePrice = selector.dataset.variantComparePrice;
      const productTitle =
        card.querySelector('.product-card__title')?.textContent?.trim() || '';

      card.dataset.url = variantUrl;

      card
        .querySelectorAll(
          '.product-card__link, .product-card__title, .product-card__carousel-container'
        )
        .forEach((link) => {
          link.href = variantUrl;
          if (productTitle) link.setAttribute('aria-label', productTitle);
        });

      card
        .querySelectorAll(
          '[data-color-swatches-hidden-count], [data-product-card-color-more-link]'
        )
        .forEach((link) => {
          link.href = variantUrl;
        });

      if (variantImage) {
        card
          .querySelectorAll('img[data-product-card-featured-image]')
          .forEach((image) => {
            image.src = variantImage;
            image.srcset = variantImage;
            image.dataset.srcset = variantImage;
            if (variantImageAlt) image.alt = variantImageAlt;
          });
      }

      const price = card.querySelector('.product-card__price-item');
      if (price && variantPrice) price.textContent = variantPrice;

      const priceCost = card.querySelector('.product-card__price-cost');
      let oldPrice = card.querySelector('.product-card__price-item-old');
      if (comparePrice) {
        if (!oldPrice && priceCost) {
          oldPrice = document.createElement('div');
          oldPrice.className = 'product-card__price-item-old';
          priceCost.appendChild(oldPrice);
        }
        if (oldPrice) oldPrice.textContent = comparePrice;
      } else if (oldPrice) {
        oldPrice.remove();
      }

      card
        .querySelectorAll(
          'input[name="id"], select[name="id"], [data-product-variant-id]'
        )
        .forEach((control) => {
          if ('value' in control) control.value = variantId;
          control.dataset.productVariantId = variantId;
        });

      card.querySelectorAll('[data-variant-card-selector]').forEach((item) => {
        const selected = item === selector;
        item.classList.toggle('is-selected', selected);
        if (selected) {
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('aria-current');
        }
      });

      card.dispatchEvent(
        new CustomEvent('variant-card:change', {
          bubbles: true,
          detail: { variantId, variantUrl }
        })
      );
    },
    true
  );
})();